"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doubleRange = void 0;
const basic_1 = require("../basic");
exports.doubleRange = (0, basic_1.applyBase)({
    rangeInputHeader: {
        p: 3,
        '.price-range-input-label': {
            mb: 2,
            fontSize: [1, 2],
            color: 'secondary',
        },
    },
    rangeInputWrapper: {
        '.range-input-text': {
            color: 'secondary',
            fontSize: [1, 2],
        },
    },
    sliderWrapper: {
        position: 'relative',
        height: '32px',
    },
});
//# sourceMappingURL=double-range.js.map